import { Button, Pagination, Table, TableBody, TableCell, TableHead, TableRow, IconButton } from "@mui/material";
import { CiCirclePlus } from "react-icons/ci";
import BadgesEditor from "./BadgesEditor";
import { useEffect, useState } from "react";
import { ApiRequest } from "GlobalFunctions";
import Box from "elements/Box";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import axios from "axios";
import { ProjectConfig } from "Global";
import { useSnackbar } from 'notistack';
import AlertDialog from "elements/AlertDialog";

export default function BadgesList(props: any) {

    const [openEditor, setOpenEditor] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [activeItem, setActiveItem] = useState<number | null>(null);
    const [openAlert, setOpenAlert] = useState(false);

    const { enqueueSnackbar } = useSnackbar();

    const [list, setList] = useState([]);
    const loadList = async () => {
        ApiRequest({
            url: '/badges/list',
            method: 'GET',
            query: {
                page: page
            },
            setResponse: (response: any) => {
                setList(response.list);
                setTotalPages(response.total_pages);
            }
        });
    }

    useEffect(() => {
        loadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const handleDelete = (badge_id: number) => {
        setActiveItem(badge_id);
        setOpenAlert(true);
    };

    const deleteItem = () => {
        const body = {
            badge_id: activeItem
        };

        axios.post(ProjectConfig.api_url + "/badges/deleteItem", body)
            .then((response) => {
                console.log(response.data);
                if (response.data.status === "success") {
                    enqueueSnackbar('Distintivo eliminado con éxito', { variant: 'success' });
                    loadList();
                }
            })
            .catch((err) => {
                console.log(err.data);
            })
            .then(() => {
                setOpenAlert(false);
            });
    };

    return (
        <>
        <div className="content">
            <div className='blog_title_row'>
                <h2 className='titles'>Distintivos</h2>

                <Button
                    variant='contained'
                    startIcon={<CiCirclePlus />}
                    onClick={() => {
                        setActiveItem(null);
                        setOpenEditor(true);
                    }}
                    >
                        Nuevo distintivo
                 </Button>
                
            </div>
            <Box className='blog_entries'>
                    <Table aria-label="sticky table"> 
                        <TableHead>
                            <TableRow>
                                <TableCell>Distintivo</TableCell>
                                <TableCell>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.length > 0 && list.map((badge: any, index: number) => (
                                <TableRow key={index}>
                                    <TableCell>{badge.badge}</TableCell>
                                    <TableCell align="right">
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Button 
                                                size="small"
                                                variant="contained"
                                                color="primary"
                                                style={{"marginRight": "10px"}}
                                                startIcon={<ModeEditIcon />}
                                                onClick={() => {
                                                    setActiveItem(badge.badge_id);
                                                    setOpenEditor(true);
                                                }}
                                            >
                                                Editar
                                            </Button>
                                            <IconButton 
                                                aria-label="delete" 
                                                color="error" 
                                                onClick={() => handleDelete(badge.badge_id)}
                                            >
                                                <DeleteOutlineOutlinedIcon /> 
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
            </Box>
            {totalPages > 1 && (
                <div className="pagination_container">
                    <Pagination 
                        count={totalPages} 
                        page={page}  
                        onChange={(event, value) => setPage(value)} 
                        color="primary"
                        style={{"marginTop": "20px","alignSelf": "center"}}
                    />
                </div>
            )}
        </div>

        <BadgesEditor 
            open={openEditor} 
            setOpen={setOpenEditor} 
            loadList={loadList} 
            badge_id={activeItem} 
        />
        <AlertDialog
            open={openAlert}
            setOpen={setOpenAlert}
            subtitle="¿Está seguro que desea eliminar este distintivo?"
            send={deleteItem}
        />
        </>
    );
};